import React from "react";

const EnableMovementPanel = (props) => {

    const{
        selectedPage
    }=props;

    return(
            <div
            className="enable_dragMode"
            style={selectedPage < 0 ? { display: 'none' } : null}
            />
    )

}

export default EnableMovementPanel;